import React from "react";
import Header from "../Page_Home/Header/";

function NoMatch() {
  return <Header notfound />;
}

export default NoMatch;
